import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import ControlledTitleInput from '../../../../components/custom-inputs/ControlledTitleInput';
import { TimedProjectEditorMenu } from '../../../../components/editor/menu-option-lists/menu-item-lists';
import ControlledTextEditor from '../../../../components/custom-inputs/ControlledTextEditor';

const Overview = () => {
  const { t } = useTranslation();
  return (
    <Stack direction="column" spacing={5}>
      <ControlledTitleInput
        label={t('tenders.projectName')}
        name="overview.name"
        placeholder={t('common.name')}
        required
      />
      <ControlledTextEditor
        label={t('tenders.companyDescription')}
        name="overview.description"
        items={TimedProjectEditorMenu}
        required
      />
    </Stack>
  );
};

export default Overview;
